// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610210437/js/" + chunkId + "." + {"44":"dc157cc3","225":"4cc33c66","481":"5ec3aa8f","486":"105a0763","770":"aa2cac40"}[chunkId] + ".0.4590891426270164.chunk.js";
};